module.exports = __webpack_public_path__ + "img/main_swiper5.23144e8e.jpg";